import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

import { checkUndefine } from '../../../../../../helpers/functions';
import DEFINE, { CUSTOM_PRICE, PRICE_MAKEUP } from '../../../../../../constants/Define';
import {
    FormWrapperItem,
    FormWrapperInputComponent,
    DatePickerComponent
} from "../../../../common/component/Index";
import Input from "../../../../common/component/Input";
import Radio from "../../../../common/component/Radio";
import Wrapper from "../../../../common/component/Wrapper";
import PriceMakeup from '../../../../modules/PriceMakeup';
import { DATE_TIME_FORMAT } from './../../../../../../constants/Define';
import { Icon } from 'antd';
import './PriceDetail.less';

class PriceDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { t, vinWonderPrice, disabled, validation } = this.props;

        return (
            <Wrapper className="price-detail-section">
                <PriceMakeup disabled={disabled}
                    validation={validation}
                    name={vinWonderPrice.name}
                    value={vinWonderPrice.value}
                    type={vinWonderPrice.type === CUSTOM_PRICE.CALCULATE_TYPE.PERCENT ? PRICE_MAKEUP.TYPE.PERCENT : PRICE_MAKEUP.TYPE.AMOUNT}
                    startDate={vinWonderPrice.startDate}
                    endDate={vinWonderPrice.endDate}
                    onChangeName={name => this.props.onChange('name', name)}
                    onChangeValue={value => this.props.onChangeValue('value', value)}
                    onChangeType={typeId => this.props.onChange('type', typeId === PRICE_MAKEUP.TYPE.PERCENT ? CUSTOM_PRICE.CALCULATE_TYPE.PERCENT : CUSTOM_PRICE.CALCULATE_TYPE.AMOUNT)}
                    onChangeDate={this.onSelectDateRange}
                    formatDate={DATE_TIME_FORMAT.DATE_TIME}
                    formatShowTime={{ format: 'HH:mm' }}
                />
            </Wrapper>
        );
    }

    onSelectDateRange = (dateRangeArr) => {
        this.props.onChange('startDate', dateRangeArr[0]);
        this.props.onChange('endDate', dateRangeArr[1]);
    }
}

PriceDetail.defaultProps = {
    onChange: () => { },
}

export default withTranslation()(PriceDetail);
